<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <template v-if="isRouterAlive">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" ></router-view>
    </template>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload:this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
body .el-table th.gutter{
  display: table-cell !important;
}
body .el-table colgroup.gutter{
  display: table-cell !important;
}
</style>
<style lang="scss">
  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
  .cascaderClass{
    /deep/ .el-cascader-menu,
    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue